'use client'

import Image, { ImageProps } from 'next/image'
import { forwardRef, LegacyRef } from 'react'

export default forwardRef(function Img(
  props: ImageProps,
  ref: LegacyRef<HTMLImageElement>
) {
  const { alt, src, style, ...rest } = props
  const isNotOptimized =
    typeof src === 'string' &&
    (!src.includes('jokrtech.com') || !src.includes('/images/'))

  return (
    <Image
      ref={ref}
      alt={alt ?? ''}
      height={props.height ?? 0}
      src={src}
      style={style ?? { objectFit: 'contain', width: 'auto', height: '100%' }}
      translate="no"
      unoptimized={isNotOptimized}
      width={0}
      {...rest}
    />
  )
})
